import React, { useState } from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { getIsVisibleInLocale } from "../../../../services/links"
import colors from "../../../../styles/colors"
import fonts from "../../../../styles/fonts"
import breakpoints from "../../../../styles/breakpoints"
import { Link } from "gatsby"

const Grid = styled.div`
  display: flex;
  gap: 30px;
`

const Card = styled.div`
  display: grid;
  gap: 13px;
  position: relative;
  flex: 1;
  max-width: calc(33% - 30px);
  width: 100%;
`

const ImageContainer = styled.div`
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.3s ease;

    background: ${(props) =>
      props.hover ? "rgba(255, 255, 255, 0.2)" : "transparent"};
  }
`

const LinkLabel = styled.div`
  ${fonts.ivyStyleLight};
  color: ${colors.trueBlack};
  font-size: 12px;
  text-transform: lowercase;
  text-align: right;
  white-space: nowrap;

  span {
    transform: ${(props) =>
      props.hover ? "translateX(2px)" : "translateX(0)"};
    transition: transform 0.2s ease;
    display: inline-block;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
  }
`

const LinkOverlay = styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const ButtonOverlay = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  cursor: pointer;
  border: none;
  padding: 0;
`

const AnchorOverlay = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const LinkCard = ({ link, handleBespokePopupClick }) => {
  const [hover, setHover] = useState(false)
  return (
    <Card
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      hover={hover ? 1 : 0}
    >
      <ImageContainer hover={hover ? 1 : 0}>
        <GatsbyImage image={link.thumbnail.gatsbyImageData} alt={link.title} />
      </ImageContainer>

      {link.openBespokeForm ? (
        <ButtonOverlay onClick={handleBespokePopupClick} />
      ) : link.externalLink ? (
        <AnchorOverlay
          href={link.externalLink}
          target="_blank"
          rel="noreferrer noopener"
        />
      ) : (
        <LinkOverlay to={link.link} />
      )}
      <LinkLabel hover={hover ? 1 : 0}>
        {link.title} <span>{` >`}</span>
      </LinkLabel>
    </Card>
  )
}

const ImageGrid = ({ links, handleBespokePopupClick }) => {
  return (
    <Grid>
      {links.map((link, index) => {
        const isVisible = getIsVisibleInLocale(link.locale)

        if (!isVisible) return null

        return (
          <LinkCard
            key={index}
            link={link}
            handleBespokePopupClick={handleBespokePopupClick}
          />
        )
      })}
    </Grid>
  )
}

export default ImageGrid
